/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Export_Font_Color_LabelInputs */



/**
* | output |
* | --- |
* | "Font Color" |
*
* @param {Video_Export_Font_Color_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_font_color_label = /** @type {((inputs?: Video_Export_Font_Color_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Font_Color_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Couleur de police")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schriftfarbe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Colore del carattere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Цвет шрифта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Color de fuente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字体颜色")
	if (locale === "ja") return /** @type {LocalizedString} */ ("フォント色")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ॉन्ट रंग")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cor da fonte")
	return /** @type {LocalizedString} */ ("Font Color")
});